import { render, staticRenderFns } from "./PointMapBigger.vue?vue&type=template&id=282349b8&"
import script from "./PointMapBigger.vue?vue&type=script&lang=ts&"
export * from "./PointMapBigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports